import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

/**
 * Breakpoints shell — préférer ce hook aux props `phoneResponsive` sur les nouveaux composants layout.
 */
export function useBreakpoint() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
  };
}
